import { render } from "./PoliciesByIin.vue?vue&type=template&id=4ed1b46e"
import script from "./PoliciesByIin.vue?vue&type=script&lang=js"
export * from "./PoliciesByIin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__